import { render, staticRenderFns } from "./StorageReports.vue?vue&type=template&id=72dd5df9&scoped=true"
import script from "./StorageReports.vue?vue&type=script&lang=js"
export * from "./StorageReports.vue?vue&type=script&lang=js"
import style0 from "./StorageReports.vue?vue&type=style&index=0&id=72dd5df9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72dd5df9",
  null
  
)

export default component.exports